<template>
  <div>
    <wc-data-box
      :title='$store.state.icons.dataBox.basics.title'
      :titleIcon='$store.state.icons.dataBox.basics.icon'
      :titleIconColor='$store.state.icons.dataBox.basics.iconColor'
      showEdit
      @edit='edit'
    >
      <wc-two-column-table :items='basicsData'></wc-two-column-table>
    </wc-data-box>
    <wc-dialog
      :showDialog='showDialog'
      :title='$store.state.icons.dataBox.basics.title'
      :icon='$store.state.icons.dataBox.basics.icon'
      width='400'
      @save='save'
      @cancel='showDialog = false'
      :disableButtons='!isFormValid'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          v-model='budgetCopy.description'
          label='Description'
          :rules='[rules.required]'
        ></v-text-field>
        <wc-datepicker v-model='budgetCopy.start_date'></wc-datepicker>
        <wc-datepicker v-model='budgetCopy.end_date'></wc-datepicker>
        <v-checkbox
          :disabled='budget.is_active'
          v-model='budgetCopy.is_active'
          label='Set as active budget?'
          :hint='budget.is_active ? "to deactivate this budget, you must activate a different one" : ""'
          persistent-hint
        ></v-checkbox>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'budget-basics',
  mixins: [formRules],
  data: () => ({
    showDialog: false,
    isFormValid: false,
    dialogTitle: 'Add New Budget',
    budgetCopy: {}
  }),
  props: {
    budget: {
      required: true
    }
  },
  computed: {
    basicsData () {
      if (this.budget) {
        return [
          { text: 'Description', value: this.budget.description },
          { text: 'Start date', value: this.$options.filters.shortDate(this.budget.start_date) },
          { text: 'End date', value: this.$options.filters.shortDate(this.budget.end_date) },
          { text: 'Currently active budget?', value: this.$options.filters.trueFalse(this.budget.is_active) }
        ]
      }
      return []
    }
  },
  methods: {
    edit () {
      this.budgetCopy = _.cloneDeep(this.budget)
      this.showDialog = true
    },
    async save () {
      this.$emit('update', this.budgetCopy)
      this.showDialog = false
    }
  }
}
</script>
